import request from '../lib/request';
import Mustache from 'mustache';
import getDataRange from '../helpers/getDataRange';
import toUtcFilterDates from '../helpers/toUtcFilterDates';
import includeTodayFilterDates from '../helpers/includeTodayFilterDates';

class Query {
    constructor(q, opts, creds = {}) {
        this.query = q;

        this.cache = {
            query: null,
            response: null,
        };

        this.creds = creds;

        Object.assign(this, opts);
        Object.assign(this, { customValues: opts ?? {} });
        this.update = this.update.bind(this);

        this.filters = window.filters;
        this.fns = [];
    }

    bind(fn) {
        this.fns.push(fn);
        return this.fns.length - 1;
    }

    async update(opts) {
        const filters = this.filters;
        const isAiTracking = window.location.pathname.split('/')[1] === 'ai-tracking';
        const {
            force = false,
            alreadyInQueue = false,
            dontUpdateExistingData = false,
            updateOnlyData = false,
        } = opts ?? {};

        if (!this.offset && !alreadyInQueue) {
            this.filters.bind(this.update);
        }

        if (filters?.filters?.dates?.label !== 'custom') {
            const filterDates = filters?.filters?.dates;
            const isTool = window.location.pathname.split('/')[1] === 'tools';
            const countFromToday = isTool || isAiTracking;

            const maxDate =
                window.waitMinMax && window.minMaxDates?.maxdate
                    ? window.minMaxDates?.maxdate?.value
                    : null;
            const filterValues = getDataRange(filterDates, countFromToday, maxDate);
            if (filterValues) filters.filters.dates.values = filterValues;
        }

        if (this['get_prior_dates']) {
            const response = this['get_prior_dates'](window.filters.get());

            this.customValues['prior_start_date'] = response.prior_start_date;
            this.customValues['prior_end_date'] = response.prior_end_date;
        }

        if (this['custom_domain']) {
            filters.filters.domain.value = this['custom_domain'];
        }

        if (this['custom_dates']) {
            filters.filters.dates.values.start_date.value = this['custom_dates']?.start_date;
            filters.filters.dates.values.end_date.value = this['custom_dates']?.end_date;
        }

        this.sql = this.filters.sql.bind(filters, this.filtersMap || undefined);

        let merged = Mustache.render(this.query, this);
        let formatted = merged.replace(/\n/g, ' ').replace(/\s\s+/g, ' ');
        let results = [];

        // hide for updating summary-query
        // if (this.cache.query == formatted) {
        //   return
        // }
        if (!dontUpdateExistingData) this.fns && this.fns.forEach((fn) => fn({ loading: true }));

        if (this.offset !== null) filters.offset = this.offset;

        // A range that ends today is sent ending tomorrow, for the request only.
        const requestFilters = includeTodayFilterDates(filters.filters);

        let response = await request(`/reports/${this.query}.json`, {
            ...filters,
            // AI Tracking reports are stored in UTC, so the locally picked range is converted
            // for the request only — `filters` itself keeps its local dates.
            filters: isAiTracking ? toUtcFilterDates(requestFilters) : requestFilters,
            force,
            ...this.customValues,
        });

        const error = response?.error;
        response = response.data;
        if (response && response[0]) {
            results = this.transformRow ? response?.map(this.transformRow) : response;
            results = this.transform ? this.transform(results) : results;
        }

        this.cache = { query: formatted, results };
        if (!dontUpdateExistingData || updateOnlyData) {
            this.fns &&
                this.fns.forEach((fn) => fn({ loading: false, data: this.cache.results, error }));
        }

        return this.cache.results;
    }

    async sort(field, dir) {
        let data = await this.get();
        dir = dir || 1;

        return data.sort((a, b) => {
            return a[field] < b[field] ? dir : -dir;
        });
    }
}

export default Query;
